import { render } from "./WalletAlbumsTable.vue?vue&type=template&id=b9c78f62&scoped=true"
import script from "./WalletAlbumsTable.vue?vue&type=script&lang=js"
export * from "./WalletAlbumsTable.vue?vue&type=script&lang=js"

import "./WalletAlbumsTable.vue?vue&type=style&index=0&id=b9c78f62&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c78f62"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTd});
